import api, { baseURL } from "../../../../utils/api"

export const getAllFlexperts = (page, limit, searchQuery) =>{
	return api.get(`${baseURL}/user/allconsultants?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}&flexExpert=true&sortBy=flexExpertAcceptedAt`);
}

export const getFlexpertRequests = (page, limit, searchQuery, country = null) => {
	let url = `${baseURL}/user/allconsultants?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}&flexpertRequest=true`;
	if (country) {
		url += `&country=${encodeURIComponent(country)}`;
	}
	return api.get(url);
}

export const updateConsultantToFlexpert = (userId, flexExpert, salaryDetails, verifiedByAdmin, showInterview) => {
	const payload = {
		userId
	};
	
	if (flexExpert !== null && flexExpert !== undefined) {
		payload.flexExpert = flexExpert;
	}
	
	if (salaryDetails !== null && salaryDetails !== undefined) {
		payload.salaryDetails = salaryDetails;
	}
	
	if (verifiedByAdmin !== null && verifiedByAdmin !== undefined) {
		payload.verifiedByAdmin = verifiedByAdmin;
	}
	
	if (showInterview !== null && showInterview !== undefined) {
		payload.showInterview = showInterview;
	}
	
	return api.put(
	  `${baseURL}/user/update-consultant-to-flexpert`,
	  payload
	);
};

